import { useState, useEffect } from "react";
import { auth } from "@/api/firebase/firebase.config";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { siteRoutes } from "@/routes/siteRoutesList";
import { useNavigate } from "react-router-dom";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { getRandomUserdata } from "../helperFunctions/getRandomUserdata";

const useSignInAnonymously = () => {
  const [status, setStatus] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);
  const setProfile = useCurrentUserProfile((s) => s.setUser);
  const navigate = useNavigate();

  const handleSignIn = async () => {
    try {
      auth.onAuthStateChanged((user) => {
        if (user) {
          setStatus(true);
          setLoading(false);
          navigate(siteRoutes["profile"]);
        } else {
          auth
            .signInAnonymously()
            .then(() => {
              const profileData = {
                ...getRandomUserdata,
                uid: auth.currentUser.uid,
              };

              collectionRef
                .profiles(brand.tenantId)
                .doc(auth.currentUser.uid)
                .set(profileData);

              setProfile(profileData);

              setStatus(true);
              navigate(siteRoutes["profile"]);
            })
            .catch((error) => {
              setError(error);
            });
        }
      });
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!status) {
      handleSignIn();
    }
  }, [status]);

  return { status, loading, error };
};

export default useSignInAnonymously;
